// ./src/pages/privates/Called/List/index.tsx
import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
  ChangeEvent,
  useContext,
} from 'react';

import { FormHandles } from '@unform/core';
import { FiDownload, FiPaperclip, FiRepeat } from 'react-icons/fi';
import {
  IoChevronBack,
  IoChevronForward,
  IoClose,
  IoDownloadOutline,
  IoArrowBack,
  IoOptions,
} from 'react-icons/io5';
import { useHistory } from 'react-router-dom';
import { setInterval } from 'timers';

import {
  HeaderNavigationPrivate,
  MenuSideBarPrivate,
  SubtitleSecondary,
  InputText,
  InputMask,
  InputSelect,
  ButtonDefault,
  Paragraph,
  ButtonMain,
  InputCheckBox,
  ListCalled,
  ButtonOutline,
} from '@components/index';
import ListCalledProviders from '@components/lists/ListCalledProviders';
import {
  ConfigStorage,
  ConfigRules,
  ConfigLabel,
  ConfigTransition,
  ConfigValues,
} from '@config/index';
import Called from '@models/Called';
import Product from '@models/Product';
import Service from '@models/Service';
import { apiRebox, apiIbge } from '@services/index';
import {
  formatCNPJ,
  formatCPF,
  formatDate,
  formatText,
} from '@utils/formatters';
import { generateDate } from '@utils/generators';
import { toastify } from '@utils/notifiers';

import {
  IResponseCalled,
  IFilterCalledFormData,
  ISearchCalledFormData,
  ISelect,
  IExportData,
  IFilterCalledsProviders,
} from './typing';

import {
  Container,
  ContainerGroup,
  Content,
  Options,
  FormSearch,
  OptionsGroup,
  FormPage,
  Pagination,
  PaginationGroup,
  PaginationGroupText,
  ModalFilter,
  FormFilter,
  FilterFieldGroup,
  FilterFieldSet,
  FilterButtons,
  ModalExportData,
  Progress,
  ProgressBar,
  ProgressText,
  ButtonExportToExcel,
} from './styles';

const CalledProvidersList: React.FC = () => {
  const { goBack } = useHistory();
  const formSearchRef = useRef<FormHandles>(null);
  const formFilterRef = useRef<FormHandles>(null);
  const formPageRef = useRef<FormHandles>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [exporting, setExporting] = useState<boolean>(false);
  const [progressExportData, setProgressExportData] = useState<number>(0);
  const [calleds, setCalleds] = useState<IResponseCalled>();
  const [page, setPage] = useState<number>(
    Number.parseInt(
      sessionStorage.getItem(ConfigStorage.REBOX_PAGINATION_CALLED_LIST_PAGE) ||
        '1',
      10,
    ),
  );
  const [totalPages, setTotalPages] = useState<number>(1);
  const [totalCalled, setTotalCalled] = useState<number>(
    Number.parseInt(
      sessionStorage.getItem(ConfigStorage.REBOX_CALLED_LIST_TOTAL) || '0',
      10,
    ),
  );
  const [search, setSearch] = useState<string>('');
  const [exportData, setExportData] = useState<IExportData[]>([]);
  const [filter, setFilter] = useState<IFilterCalledsProviders>(
    JSON.parse(
      sessionStorage.getItem(ConfigStorage.REBOX_FILTERS_CALLED_LIST) || '{}',
    ),
  );
  const [filterIsActive, setFilterIsActive] = useState<boolean>(
    !!sessionStorage.getItem(ConfigStorage.REBOX_FILTERS_CALLED_LIST),
  );

  const [products, setProducts] = useState<ISelect[]>([]);
  const [services, setServices] = useState<ISelect[]>([]);
  const [isDisabledFilter, setIsDisabledFilter] = useState<boolean>(true);
  const [isOpenModalFilter, setIsOpenModalFilter] = useState<boolean>(false);
  const [isOpenModalExportData, setIsOpenModalExportData] = useState<boolean>(
    false,
  );

  // Uso temporário - Correçào de bug
  const [tmpCalleds, setTmpCalleds] = useState<IResponseCalled>();

  const [tmpTotalPages, setTmpTotalPages] = useState<number>(1);
  const [tmpTotalCalled, setTmpTotalCalled] = useState<number>(
    Number.parseInt(
      sessionStorage.getItem(ConfigStorage.REBOX_CALLED_LIST_TOTAL) || '0',
      10,
    ),
  );

  const buildTheQueryUrl = (value: number): string => {
    let url = `/called?page=${value}&per_page=${ConfigRules.rebox.pagination.called.itemLimit}&details=all&status=${ConfigValues.rebox.called.status.done}`;

    if (search) {
      // Busca por nome, email, cpf etc...
      url = `${url}&query=${search}`;
    } else {
      // Buscar pelo filtro de status, estado etc
      const { cpf_cnpj, license_plate, service_payment_status, phone } = filter;

      if (cpf_cnpj) {
        url = `${url}&${
          cpf_cnpj.length === 11
            ? 'who_is_answering_cpf'
            : 'who_is_answering_cnpj'
        }=${cpf_cnpj}`;
      }

      if (phone) {
        url = `${url}&who_is_answering_phone=${phone
          .replaceAll('(', '')
          .replaceAll(')', '')
          .replaceAll('-', '')
          .replaceAll(' ', '')}`;
      }

      if (license_plate) {
        url = `${url}&license_plate=${license_plate}`;
      }
      if (service_payment_status) {
        url = `${url}&service_payment_status=${service_payment_status}`;
      }
    }
    return url;
  };

  const getServices = useCallback(async () => {
    try {
      const { data: response } = await apiRebox.get(`/services`);

      const responseServices: Service[] = response.data;
      const servicesUpdated: ISelect[] = [
        {
          label: 'Todos',
          value: 'UNDEFINED',
        },
      ];

      responseServices.forEach(element => {
        servicesUpdated.push({
          label: formatText.capitalizedFirstLetter(element.name),
          value: element.id,
        });
      });

      setServices(servicesUpdated);
    } catch (error) {
      toastify(`Houve um error ao buscar os serviços.`, 'error');
    }
  }, []);

  const getCalleds = async (desiredPage = 1) => {
    try {
      setLoading(prevState => !prevState);

      const builtUrl = buildTheQueryUrl(desiredPage);
      const { data: responseContracts } = await apiRebox.get(builtUrl);
      setCalleds(responseContracts);

      const { header }: IResponseCalled = responseContracts;
      setTotalCalled(header.total);
      setTotalPages(Math.ceil(header.total / header.per_page));
      formPageRef.current?.setData({ currentPage: desiredPage });
    } catch (error) {
      toastify('Ops! Houve um erro ao tentar buscar os acionamentos.', 'error');
    } finally {
      setLoading(prevState => !prevState);
    }
  };

  const getProducts = useCallback(async () => {
    try {
      const { data: response } = await apiRebox.get(`/products?per_page=20`);
      const products_found: Product[] = response.data;
      const productsUpdate: ISelect[] = [
        {
          label: 'Todos',
          value: 'UNDEFINED',
        },
      ];
      products_found.forEach(item => {
        productsUpdate.push({
          label: item.name.toUpperCase(),
          value: item.id || '',
        });
      });
      setProducts(productsUpdate);
    } catch (error) {
      toastify('Houve um erro ao buscar os produtos disponíveis.', 'error');
    }
  }, []);

  const [cpfCnpjFilter, setCpfCnpjFilter] = useState('');

  const handleSearchCalleds = useCallback((data: ISearchCalledFormData) => {
    formFilterRef.current?.reset();
    setSearch(data.search.toLowerCase());
    setPage(1);
  }, []);

  const handleFilterCalleds = (data: IFilterCalledsProviders) => {
    formSearchRef.current?.reset();

    const allDataFilter: IFilterCalledsProviders = {
      cpf_cnpj:
        cpfCnpjFilter.length === 14
          ? formatCPF.removeMask(cpfCnpjFilter)
          : formatCNPJ.removeMask(cpfCnpjFilter),
      license_plate: data.license_plate ? data.license_plate : '',
      service_payment_status: data.service_payment_status || '',
      phone: data.phone || '',
    };

    sessionStorage.setItem(
      ConfigStorage.REBOX_FILTERS_CALLED_LIST,
      JSON.stringify(allDataFilter),
    );
    setFilter(allDataFilter);
    setIsOpenModalFilter(prevState => !prevState);
    setPage(1);
    setFilterIsActive(true);
  };

  const handleExportData = useCallback(async () => {
    try {
      setExporting(prevState => !prevState);
      const calledsExportData: IExportData[] = [];
      let calledsReturns: Called[] = [];
      const arrayUrls: string[] = [];
      const numberPages = Math.ceil(
        totalPages ||
          ConfigRules.rebox.pagination.called.itemLimit /
            ConfigRules.rebox.pagination.called.itemLimit,
      );

      for (let i = 1; i <= numberPages; i++) {
        arrayUrls.push(buildTheQueryUrl(i));
      }

      // (page / totalPage) * 100 = x%
      const calc = (1 / arrayUrls.length) * 100;
      const percentage = Number.parseFloat(
        (Math.round((Math.floor(calc) * 1000) / 10) / 100).toFixed(1),
      );

      for await (const url of arrayUrls) {
        const { data: responseCalled } = await apiRebox.get(url);
        calledsReturns = [...calledsReturns, ...responseCalled.data];
        setProgressExportData(prevValue => {
          let valueDefined = prevValue;
          if (percentage === 0) {
            valueDefined += calc;
          } else {
            valueDefined += percentage;
          }
          const [units, decimals] = valueDefined.toFixed(1).split('.');
          return Number.parseFloat(
            decimals ? `${units}.${decimals.substring(0, 2)}` : units,
          );
        });
      }
      calledsReturns.forEach(item => {
        calledsExportData.push({
          called_code: item.code || '',
          called_date_created: formatDate.addMask(item.date_created),
          called_appointment_date: formatDate.addMask(
            item.appointment_date || item.date_created,
          ),
          services_name: item.service?.name || '',
          called_vehicle_situation:
            ConfigTransition.rebox_called_vehicle_situation[
              item.vehicle_situation
                ? item.vehicle_situation.toLowerCase()
                : 'undefined'
            ],
          called_location_type:
            ConfigTransition.rebox_called_location_type[
              item.location_type
                ? item.location_type?.toLowerCase()
                : 'undefined'
            ],
          called_status:
            ConfigTransition.rebox_called_status[
              item.status ? item.status.toLowerCase() : 'undefined'
            ],
          called_call_initiation_date: formatDate.addMask(
            item.call_initiation_date || '0000-00-00',
          ),
          called_service_start_date: formatDate.addMask(
            item.service_start_date || '0000-00-00',
          ),
          called_closing_date: formatDate.addMask(
            item.closing_date || '0000-00-00',
          ),
          vehicle_license_plate: item.vehicle
            ? item.vehicle.license_plate.toUpperCase()
            : '',
          vehicle_brand: item.vehicle ? item.vehicle.brand.toUpperCase() : '',
          vehicle_model: item.vehicle ? item.vehicle.model.toUpperCase() : '',
          called_source_address: item.source_address?.full_address
            ? item.source_address.full_address
            : '',
          called_destination_address: item.destination_address?.full_address
            ? item.destination_address.full_address
            : '',
          called_distance_between_points_in_km: `${
            item.distance_between_points_in_km || 0
          }`,
          customer_name: item.customer?.name || '',
          customer_cpf_or_cnpj: item.customer?.cpf || item.customer?.cnpj || '',
          customer_email: item.customer?.email || '',
          customer_cellphone: item.customer?.cellphone || '',
          provider_name: item.who_is_answering?.name || '',
          provider_cpf_or_cnpj:
            item.who_is_answering?.cpf || item.who_is_answering?.cnpj || '',
          provider_email: item.who_is_answering?.email || '',
          provider_cellphone: item.who_is_answering?.cellphone || '',
        });
      });
      setProgressExportData(100);
      setExportData(calledsExportData);
    } catch (error) {
      toastify('Sinto muito, não conseguimos exportar os dados.', 'error');
    } finally {
      setExporting(prevState => !prevState);
    }
  }, [totalPages]);

  const handleDownloadFile = useCallback(() => {
    setProgressExportData(0);
    setExportData([]);
    setIsOpenModalExportData(prevState => !prevState);
    toastify('Download do relatório de clientes foi iniciado!', 'success');
  }, []);

  const cleanFilter = useCallback(() => {
    formFilterRef.current?.reset();
    sessionStorage.removeItem(ConfigStorage.REBOX_FILTERS_CALLED_LIST);
    setFilter({} as IFilterCalledsProviders);
    setFilterIsActive(false);
    setIsOpenModalFilter(prevState => !prevState);
  }, []);

  const handleGoBack = useCallback(() => {
    sessionStorage.removeItem(ConfigStorage.REBOX_PAGINATION_CALLED_LIST_PAGE);
    sessionStorage.removeItem(ConfigStorage.REBOX_FILTERS_CALLED_LIST);
    goBack();
  }, []);

  const handleRefreshList = useCallback(async () => {
    try {
      const { data: responseContracts } = await apiRebox.get(`/called`, {
        params: {
          page,
          status: ConfigValues.rebox.called.status.done,
        },
      });
      setTmpCalleds(responseContracts);

      const { total, per_page } = responseContracts.header;
      setTmpTotalCalled(total);
      setTmpTotalPages(Math.ceil(total / per_page));
      // formPageRef.current?.setData({ currentPage: 1 });
    } catch (error) {
      console.error(`Refresh não realizado`);
    }
  }, [page, filter]);

  useEffect(() => {
    getCalleds(page);
    handleRefreshList();
    sessionStorage.setItem(
      ConfigStorage.REBOX_PAGINATION_CALLED_LIST_PAGE,
      `${page}`,
    );
  }, [page, search, filter]);

  useEffect(() => {
    getServices();
    getProducts();
    const interval = setInterval(() => handleRefreshList(), 1000 * 15);
    return () => clearInterval(interval);
  }, []);

  return (
    <Container>
      <HeaderNavigationPrivate />
      <ContainerGroup>
        <MenuSideBarPrivate />
        <Content>
          <SubtitleSecondary textAlign="start">
            Cobranças Prestadores
          </SubtitleSecondary>
          <Options>
            <OptionsGroup>
              <ButtonDefault iconLeft={IoArrowBack} onClick={handleGoBack} />
              <ButtonOutline
                iconLeft={IoOptions}
                onClick={() => setIsOpenModalFilter(prevState => !prevState)}
              />

              {progressExportData === 100 || exporting ? (
                <ButtonOutline
                  iconLeft={FiDownload}
                  onClick={() =>
                    setIsOpenModalExportData(prevState => !prevState)
                  }
                >
                  {isOpenModalExportData ? '' : `${progressExportData}%`}
                </ButtonOutline>
              ) : (
                <ButtonOutline
                  iconLeft={FiPaperclip}
                  onClick={() =>
                    setIsOpenModalExportData(prevState => !prevState)
                  }
                />
              )}
              <ButtonOutline
                iconLeft={FiRepeat}
                type="reset"
                onClick={() => {
                  formFilterRef.current?.reset();
                  sessionStorage.removeItem(
                    ConfigStorage.REBOX_FILTERS_CALLED_LIST,
                  );
                  setFilter({} as IFilterCalledsProviders);
                  setFilterIsActive(false);
                }}
              />
            </OptionsGroup>
            <FormSearch ref={formSearchRef} onSubmit={handleSearchCalleds}>
              <InputText
                name="search"
                placeholder="Pesquisar..."
                title="Por nome, e-mail, CPF ou CNPJ do cliente e outros"
                showIconSearch={true}
                widthIconSearch={16}
                nameColorIconSearch={'gray'}
                opacityIconSearch={0.5}
                onChange={event => {
                  if (event.target.value === '') {
                    setSearch('');
                  }
                }}
              />
            </FormSearch>
          </Options>
          <Pagination>
            <ButtonDefault
              style={{
                borderRadius: '8px 0 0 8px',
                maxWidth: 100,
              }}
              disabled={page === 1}
              isDisable={page === 1}
              onClick={() => setPage(1)}
            >
              Primeira
            </ButtonDefault>
            <ButtonDefault
              iconLeft={IoChevronBack}
              style={{
                borderRadius: '0',
                maxWidth: 30,
                padding: '0 5px',
                margin: '0 5px',
              }}
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
            />
            <PaginationGroup>
              <FormPage
                ref={formPageRef}
                onSubmit={() => console.log('')}
                initialData={{ currentPage: page }}
              >
                <InputText
                  name="currentPage"
                  value={page}
                  type="number"
                  min="1"
                  onChange={event => {
                    if (!(event.target.value === '')) {
                      setPage(Number.parseInt(event.target.value, 10));
                    }
                  }}
                />
              </FormPage>
              <PaginationGroupText>de {totalPages}</PaginationGroupText>
            </PaginationGroup>

            <ButtonDefault
              iconLeft={IoChevronForward}
              style={{
                borderRadius: '0',
                maxWidth: 30,
                padding: '0 5px',
                margin: '0 5px',
              }}
              disabled={page === totalPages}
              onClick={() => setPage(page + 1)}
            />
            <ButtonDefault
              style={{
                borderRadius: '0 8px 8px 0',
                maxWidth: 100,
              }}
              disabled={page === totalPages}
              isDisable={page === totalPages}
              onClick={() => setPage(totalPages)}
            >
              Última
            </ButtonDefault>
          </Pagination>
          <ListCalledProviders
            calleds={calleds?.data}
            loading={loading}
            showTotal={true}
            totalValue={calleds?.header.total}
          />
          <Pagination>
            <ButtonDefault
              style={{
                borderRadius: '8px 0 0 8px',
                maxWidth: 100,
              }}
              disabled={page === 1}
              isDisable={page === 1}
              onClick={() => setPage(1)}
            >
              Primeira
            </ButtonDefault>
            <ButtonDefault
              iconLeft={IoChevronBack}
              style={{
                borderRadius: '0',
                maxWidth: 30,
                padding: '0 5px',
                margin: '0 5px',
              }}
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
            />
            <PaginationGroup>
              <FormPage
                ref={formPageRef}
                onSubmit={() => console.log('')}
                initialData={{ currentPage: page }}
              >
                <InputText
                  name="currentPage"
                  type="number"
                  min="1"
                  value={page}
                  onChange={event => {
                    if (!(event.target.value === '')) {
                      setPage(Number.parseInt(event.target.value, 10));
                    }
                  }}
                />
              </FormPage>
              <PaginationGroupText>de {totalPages}</PaginationGroupText>
            </PaginationGroup>

            <ButtonDefault
              iconLeft={IoChevronForward}
              style={{
                borderRadius: '0',
                maxWidth: 30,
                padding: '0 5px',
                margin: '0 5px',
              }}
              disabled={page === totalPages}
              onClick={() => setPage(page + 1)}
            />
            <ButtonDefault
              style={{
                borderRadius: '0 8px 8px 0',
                maxWidth: 100,
              }}
              disabled={page === totalPages}
              isDisable={page === totalPages}
              onClick={() => setPage(totalPages)}
            >
              Última
            </ButtonDefault>
          </Pagination>
        </Content>
      </ContainerGroup>
      <ModalFilter
        isOpen={isOpenModalFilter}
        onRequestClose={() => setIsOpenModalFilter(prevState => !prevState)}
        contentLabel="FilterCustomer"
      >
        <ButtonDefault
          iconLeft={IoClose}
          style={{
            position: 'absolute',
            top: 10,
            right: 10,
            maxWidth: 50,
            padding: 0,
          }}
          onClick={() => setIsOpenModalFilter(prevState => !prevState)}
        />
        <FormFilter
          ref={formFilterRef}
          onSubmit={handleFilterCalleds}
          initialData={[]}
        >
          <FilterFieldSet>
            <Paragraph
              nameColor="black"
              textAlign="start"
              style={{ marginBottom: '1vh', fontWeight: 500 }}
            >
              Por placa
            </Paragraph>
            <InputMask
              name="license_plate"
              mask="aaa-9*99"
              placeholder="Placa do veículo"
              style={{ textTransform: 'uppercase' }}
              onChange={event => {
                if (!event.target.value.includes('_')) {
                  // setVehicleLicensePlate(event.target.value);
                } else {
                  // setVehicleLicensePlate('');
                  // setAlertCheckVehicle(0);
                }
              }}
              autoFocus
            />
          </FilterFieldSet>

          <FilterFieldSet>
            <Paragraph
              nameColor="black"
              textAlign="start"
              style={{ marginBottom: '1vh', fontWeight: 500 }}
            >
              Por CPF/CNPJ
            </Paragraph>
            <InputText
              name="cpf_cnpj"
              onChange={e => setCpfCnpjFilter(e.target.value)}
              placeholder="Número do documento"
            />
          </FilterFieldSet>

          <FilterFieldSet>
            <Paragraph
              nameColor="black"
              textAlign="start"
              style={{ marginBottom: '1vh', fontWeight: 500 }}
            >
              Por Telefone
            </Paragraph>
            <InputMask
              name="phone"
              mask={'(99) 9999-99999'}
              placeholder="Informe o telefone"
            />
          </FilterFieldSet>

          <FilterFieldSet>
            <Paragraph
              nameColor="black"
              textAlign="start"
              style={{ marginBottom: '1vh', fontWeight: 500 }}
            >
              Por status
            </Paragraph>
            <InputSelect
              name="service_payment_status"
              placeholder="Selecione"
              options={ConfigLabel.rebox.filter.called.servicePaymentStatus}
            />
          </FilterFieldSet>

          <FilterButtons>
            <ButtonMain type="submit">Filtrar</ButtonMain>
            <ButtonDefault type="reset" onClick={cleanFilter}>
              Resetar
            </ButtonDefault>
          </FilterButtons>
        </FormFilter>
      </ModalFilter>
      <ModalExportData
        isOpen={isOpenModalExportData}
        onRequestClose={() => setIsOpenModalExportData(prevState => !prevState)}
        contentLabel="ExportData"
      >
        <ButtonDefault
          iconLeft={IoClose}
          style={{
            position: 'absolute',
            top: 10,
            right: 10,
            maxWidth: 50,
            padding: 0,
          }}
          onClick={() => setIsOpenModalExportData(prevState => !prevState)}
        />
        <Paragraph style={{ fontWeight: 600, marginBottom: '1.5vh' }}>
          Exportar resultado
        </Paragraph>
        <Paragraph nameColor="black" opacity={0.6}>
          Os registros retornados do filtro ou da pesquisa serão exportados para
          um arquivo excel.
        </Paragraph>
        <Progress percentage={progressExportData}>
          <ProgressText>{progressExportData}%</ProgressText>
          <ProgressBar className="active" />
          <ProgressBar />
        </Progress>
        {progressExportData < 100 && (
          <ButtonMain
            loading={exporting}
            style={{ maxWidth: 200, margin: '0 auto' }}
            onClick={() => handleExportData()}
          >
            Iniciar
          </ButtonMain>
        )}
        {progressExportData === 100 && (
          <ButtonExportToExcel
            headers={ConfigLabel.rebox.export.excel.called}
            data={exportData}
            filename={`acionamentos-${generateDate.now().split(' ')[0]}.xls`}
            onClick={handleDownloadFile}
          >
            <IoDownloadOutline size={18} />
            Baixar
          </ButtonExportToExcel>
        )}
      </ModalExportData>
    </Container>
  );
};

export default CalledProvidersList;
